import classNames from "classnames";
import React from "react";

export type CardFooterComponentProps = {};

export type CardFooterProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardFooterComponentProps, "div">;

const CardFooter = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardFooterProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = classNames(className, "card-footer");

    return (
        <Tag {...attributes} className={classes} />
    );
};

export { CardFooter };
